import { PolicyList } from '../components/PolicyList';
import { usePolicyListService } from '../services/usePolicyListService';

export const PolicyListContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { policyList, policyListOpenStatus, handleBoxClick } = usePolicyListService();

  return (
    <PolicyList policyList={policyList} policyListOpenStatus={policyListOpenStatus} handleBoxClick={handleBoxClick} />
  );
};
